import { render, staticRenderFns } from "./ContractGoodsInfo.vue?vue&type=template&id=b5661dd2"
import script from "./ContractGoodsInfo.vue?vue&type=script&lang=js"
export * from "./ContractGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractGoodsInfo.vue?vue&type=style&index=0&id=b5661dd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports